import React, { useEffect, useState } from "react";
import AttachmentModal from "features/attachments/AttachmentModal";
import Twilio from "services/twilioService/Twilio";
import shallow from "zustand/shallow";
import MailgunEmail from "services/mailgunService/MailgunEmail";
import NoteButton from "features/notes/NoteButton";
import useCurrentAccountStore from "./AccountStore";
import { saveAccountTable } from "./AccountAPI";
import { showApiError } from "../utils/errorRoutingUtils";
import { retrieveFailAlert, saveFailAlert } from "../utils/alertUtils";
import history from "utils/createBrowserHistory";
import { MessageZone, PATHS } from "../constants/Constants";
import useRoute from "../hooks/useRoute";
import InitializeTemplateVars from "../utils/initializeTemplateVars";
import { TemplateVariableProvider } from "../context/TemplateVariableContext";
import AccountHook from "./AccountHook";
import ActionBar from "../components/ActionBar";
import { getDealDetails } from "../api/DealAPI";
import useSetDeal from "../features/deal/hooks/useSetDeal";
import { getSettings } from "../api/SettingsAPI";
import Communication from "../services/communication/Communication";
import RegistrationLink from "../services/registrationLink/RegistrationLink";
import ChildrenModal from "../components/modals/ChildrenModal";
import AccountAddPage from "./AccountAddPage";
import AccountModificationPage from "./AccountModificationPage";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";
import LeaseEndWizard from "./LeaseEnd/LeaseEndWizard";
import { usePaymentProcessor } from "../hooks/usePaymentProcessor";

const AccountActionBar = () => {
	const { isXplorPay } = usePaymentProcessor();
	const { account, buyer, editAccountNotes } = useCurrentAccountStore(
		(state) => state,
		shallow
	);
	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
	const toggleActionsModal = () => setActionsModal(!actionsModal);
	const [actionsModal, setActionsModal] = useState(false);

	const dealDetailPage = useRoute(PATHS.DEAL_DETAIL);
	const accountModificationPage = useRoute(PATHS.ACCT_MODIFY);

	const setDeal = useSetDeal();
	const [handleSaveNotes, setHandleSaveNotes] = useState(false);
	const shouldSaveNotes = () => setHandleSaveNotes(!handleSaveNotes);
	useEffect(() => {
		saveNotes();
		// eslint-disable-next-line
	}, [handleSaveNotes]);
	const saveNotes = () => {
		if (account.id != null) {
			let modifiedAccount = { ...account };
			const modifiedNotes = Array.isArray(account.notes)
				? JSON.stringify(account.notes)
				: [{ description: account.notes }];

			modifiedAccount.notes = modifiedNotes;
			saveAccountTable(modifiedAccount).then(
				(response) => {},
				(err) => {
					if (!err.isGeneralError) {
						showApiError(err, saveFailAlert);
					}
				}
			);
		}
	};
	// const { editID } = useCurrentDealStore((state) => state, shallow);
	// Gets the deal data and routes to detail page
	const getDealData = (id) => {
		Promise.all([
			getSettings(account.dealerID, account.locationID),
			getDealDetails(id),
		])
			.then((res) => {
				setDeal(res[1].data.content);

				history.push(dealDetailPage, { ID: id });
			})
			.catch((error) => showApiError(error, retrieveFailAlert));
	};
	const save = AccountHook();
	// Modification of account
	const [isModifyOpen, setIsModifyOpen] = useState(false);
	const toggleModify = () => setIsModifyOpen(!isModifyOpen);

	// Lease End Modal
	const [isLeaseEndOpen, setIsLeaseEndOpen] = useState(false);
	const toggleLeaseEnd = () => setIsLeaseEndOpen(!isLeaseEndOpen);

	return (
		<>
			<ActionBar
				isMobile={isMobile}
				toggleActionsModal={toggleActionsModal}
				actionsModal={actionsModal}
				modalTitle="BHPH Actions"
			>
				<div className="action-bar content">
					<TemplateVariableProvider>
						<InitializeTemplateVars messageZone={MessageZone.ACCOUNT}>
							{/* <Twilio
								sendToNumber={buyer.cellPhone}
								accountID={account.id}
								personType={"Account"}
							/>
							<MailgunEmail customerEmail={buyer.email} /> */}
							<Communication
								customerEmail={buyer?.email}
								sendToNumber={buyer?.cellPhone}
								accountID={account.id}
								personType={"Account"}
							/>
							{isXplorPay && (
								<RegistrationLink
									customerEmail={buyer?.email}
									sendToNumber={buyer?.cellPhone}
									accountID={account.id}
								/>
							)}
						</InitializeTemplateVars>
					</TemplateVariableProvider>
					<AttachmentModal relatedID={account.id} type="account" />
					<NoteButton
						notes={account.notes}
						editNotes={editAccountNotes}
						saveNotes={shouldSaveNotes}
					/>

					<button
						className="btn btn-primary"
						onClick={() => getDealData(account.dealRecNum)}
					>
						Deal Details
					</button>
					<button
						className="btn btn-warning"
						onClick={() => {
							// setIsModifyOpen(true);
							history.push(accountModificationPage, {
								accountID: account.id,
							});
						}}
						disabled={!p.loanModification}
						// onClick={() => getDealData(account.dealRecNum)}
					>
						Loan Modification
					</button>

					{(account.payoffMethod === 4 || account.payoffMethod === 5) && account.status === 0 && (
						<button
							className="btn btn-success"
							onClick={toggleLeaseEnd}
							title="Process Lease/RTO End - Buyout or Return"
						>
							🔚 {account.payoffMethod === 4 ? "Lease" : "RTO"} End
						</button>
					)}
				</div>
			</ActionBar>
			<ChildrenModal
				size="xl"
				modal={isModifyOpen}
				toggle={toggleModify}
				modalTitle="Loan Modification"
			>
				<AccountAddPage accountID={account.id} />
			</ChildrenModal>

			<ChildrenModal
				size="lg"
				modal={isLeaseEndOpen}
				toggle={toggleLeaseEnd}
				//				modalTitle="Lease End Process"
			>
				<LeaseEndWizard />
			</ChildrenModal>
		</>
	);
};

export default AccountActionBar;
